<template>
  <div id="main" class="mt-4">
    <div>
      <h1>NIH Recovery Act Investment Reports</h1>
      <p>
        NIH is grateful to the Administration, the Congress, and the public for
        its continuing support for medical research. Last year, awarded 10
        billion dollars in the Stimulus Bill, the NIH was given an unprecedented
        opportunity to provide jobs and invest in cutting edge science with the
        goal of improving the nation’s health! It is a time of great scientific
        opportunity! Listed here are 166 topics in biomedical research -
        investments in new knowledge – that were made possible by ARRA. While
        these investment reports describe work being supported through
        approximately 2000 ARRA grants, this is only a subset of the more than
        12,000 grants that have been awarded through ARRA.
      </p>
    </div>
    <div class="mt-4" v-if="serviceFailure">
      <b-alert show variant="danger">{{ message }}</b-alert>

      <b-button class="mt-4" variant="outline-primary" :href="`/recovery`"
        >Go To NIH Recovery Act Archive</b-button
      >
    </div>
    <div id="btable" class="overflow-auto" v-else>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="investment-reports-table"
        align="right"
      ></b-pagination>

      <b-table
        striped
        responsive
        id="investment-reports-table"
        :busy.sync="isBusy"
        :fields="fields"
        tableClass="cat-table"
        :items="investmentReports"
        :per-page="perPage"
        :current-page="currentPage"
        :outlined="true"
      >
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell()="data">
          <a :href="`?reportName=investment&id=${data.item.id}`">
            {{ data.item.reportName }}
          </a>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { data } from "@/shared";
import { SERVICE_UNAVAILABLE_ERROR_MSG } from "@/shared/config.js";
export default {
  name: "InvestmentReports",

  data() {
    return {
      isBusy: false,
      investmentReports: [],
      serviceFailure: false,
      message: SERVICE_UNAVAILABLE_ERROR_MSG,
      rows: 0,
      fields: [
        {
          key: "InvestmentName",
          label: "Report Title"
        }
      ],
      currentPage: 1,
      perPage: 10
    };
  },
  async created() {
    await this.getInvestmentReportData();
  },

  methods: {
    async getInvestmentReportData() {
      this.investmentReports = [];

      this.isBusy = true;
      this.investmentReports = await data.getInvestments(this.id);
      if (!this.investmentReports.length) {
        this.serviceFailure = true;
      } else {
        this.rows = this.investmentReports.length;
      }
      this.isBusy = false;
    }
  }
};
</script>
